import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

import { cn } from "..";

const NumberFieldScrubArea = forwardRef<HTMLDivElement, React.ComponentPropsWithRef<typeof BaseNumberField.ScrubArea>>(
  (props, forwardedRef) => {
    const { className, ...scrubProps } = props;
    return (
      <BaseNumberField.ScrubArea
        {...scrubProps}
        ref={forwardedRef}
        className={cn(
          "px-3 flex cursor-ew-resize items-center border-r border-primary-darker-gray bg-primary-gray",
          "font-medium text-[14px] text-primary-dark-gray select-none",
          className,
        )}
      />
    );
  },
);

NumberFieldScrubArea.displayName = "NumberField.ScrubArea";

export default NumberFieldScrubArea;
